import { myAxios } from "../../utils/serverContextPath";

export const getActivityTypeById = (id) => {
  return myAxios.get(`activitytype/getbyid/${id}`);
};

export const getActivityTypeAllPage = (
  keyword = "",
  pageNumber = 0,
  itemsPerPage = 10,
  sortList = [],
  sortOrder = "DESC"
) => {
  return myAxios.get("activitytype/getallpage", {
    params: {
      keyword,
      page: pageNumber,
      size: itemsPerPage,
      sortList,
      sortOrder,
    },
  });
};

export const getActivityTypebycropsorlivestockpage = (
  val = "",
  keyword = "",
  pageNumber = 0,
  itemsPerPage = 10,
  sortList = [],
  sortOrder = "DESC"
) => {
  return myAxios.get("activitytype/getbycropsorlivestockpage", {
    params: {
      val,
      keyword,
      page: pageNumber,
      size: itemsPerPage,
      sortList,
      sortOrder,
    },
  });
};


export const getAllActivityType = (
  keyword = "",
  sortList = [],
  sortOrder = "DESC"
) => {
  return myAxios.get("activitytype/getall", {
    params: {
      keyword,
      sortList,
      sortOrder,
    },
  });
};

export const deleteActivityType = (id) => {
  return myAxios.delete(`activitytype/delete/${id}`);
};

export const postActivityType = (data) => {
  return myAxios.post("activitytype/save/insert", data);
};

export const updateActivityType = (data) => {
  return myAxios.post("activitytype/save/Update", data);
};

export const findSimilarActivityType = (
  keyword,
  tauxsimilarity = 0.8,
  sortList = [],
  sortOrder = "DESC"
) => {
  return myAxios.get("activityType/similarity", {
    params: {
      keyword,
      tauxsimilarity,
      sortList,
      sortOrder,
    },
  });
};

//----




export const getActivitytypeByCropsOrLivestock = (
  val = "",
  keyword = "",
  sortList = [],
  sortOrder = "DESC"
) => {
  return myAxios.get("activitytype/getbycropsorlivestock", {
    params: {
      val,
      keyword,
      sortList,
      sortOrder,
    },
  });
}

